import { render, staticRenderFns } from "./term.vue?vue&type=template&id=a67ddbe0&"
import script from "./term.vue?vue&type=script&lang=js&"
export * from "./term.vue?vue&type=script&lang=js&"
import style0 from "./term.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports